/* eslint-disable dot-notation */
/* eslint-disable max-len */
/* eslint-disable no-console */
import React, { useContext, useEffect, useRef, useState } from 'react';
import useInterSectionObserver from '../../../../../../../libs/CustomHooks/useIntersectionObserver';
import { catchErr } from '../../../../../../../libs/HelperContent';
import { getComments } from '../../../../../../actions/feeds_actions_new';
import { useSelector } from 'react-redux';
import { LanguageContext } from '../../../../../../../libs/Context';
import Replies from './Replies';
import { commentContext } from '../..';
import { feedActionContext } from '../../../../..';
import CommentShimmer from '../../../../../../../components/Common/Shimmer/NewsFeedShimmer/CommentShimmer';
import { getEventComments } from '../../../../../../actions/recognition_actions';
import PostReplies from './PostReplies';
import { feedActionContextFromExternal } from '../../../../ExternalRequest';

interface Props{
	cmntData:any;
	openReplies:()=>void;
	from:'events'|'feeds';
	selEvent:any;
	commntsData:any[];
	setCommntsData:(val)=>void;
}

const CommentReply = (props:Props) =>
{
	const { cmntData, openReplies, from, selEvent, commntsData, setCommntsData } = props;
	const [ loading, setLoading ] = useState<boolean>(false);
	const { setAction, callApi } = useContext(commentContext);
	const { feedCardActn } = useContext(window.location.pathname.includes('news') ? feedActionContext : feedActionContextFromExternal);

	const [ page, setPage ] = useState<number>(0);
	const loaderRef = useRef<any>(false);
	const lastEleRef = useRef<any>();
	const [ repliesData, setRepliesData ] = useState<any[]>([]);
	const [ repliesCount, setRepliesCount ] = useState<number>(0);

	const userData = useSelector((state:any) => state?.mysession?.session);
	const { language } = useContext(LanguageContext);

	const [ comment, setComment ] = useState<string>('');

	const LoadMoreList = useInterSectionObserver({ lastEleRef,
		loaderRef,
		count : repliesCount,
		data  : repliesData,
		setPage });

	const getCmmntsCount = async (query:any) =>
	{
		try
		{
			query.count = true;
			const path = feedCardActn[1]?._id;
			const res = await getComments(path, query);

			if (res?.status)
			{
				setRepliesCount(res?.count);
			}
			else
			{
				setRepliesCount(0);
			}
		}
		catch (err)
		{
			console.log('---------------', err);
			setLoading(false);
			catchErr(err);
		}
	};
	const afterApiCall = (res, query) =>
	{
		if (res?.status)
		{
			const resp = from === 'events' ? res?.data : res?.response;
			const resCnt = from === 'events' ? res?.data?.length : res?.response.length;

			page === 0
				? setRepliesData(resp)
				: setRepliesData((prev) => ([ ...prev, ...resp ]));

			res?.response?.length >= 12
				? getCmmntsCount(query)
				: setRepliesCount(resCnt);
		}
		else
		{
			setRepliesData(repliesData ?? []);
			setRepliesCount(repliesCount ?? 0);
		}
	};

	const getCommentsList = async () =>
	{
		setLoading(page === 0);
		try
		{
			const query :any = {
				commentId : from === 'events' ? cmntData?.commentId : cmntData?._id,
				uid       : userData?.userId,
				comid     : userData?.companyId,
				empRole   : userData?.empRole,
				role      : userData?.role,
				skip      : page,
				limit     : 12
			};

			if (from === 'events')
			{
				query.eventId = selEvent?.eventId;

				// Correct way to add `startedAt` only if `selEvent?.type !== 1`
				if (from === 'events')
				{
					query.eventId = selEvent?.eventId;

					if (selEvent?.type !== 1)
					{
						const eventDate = new Date(); // Current date

						eventDate.setHours(0, 0, 0, 0); // Set time to midnight
						query.startedAt = eventDate.getTime(); // Convert to milliseconds
					}
				}
			}

			const path = feedCardActn[1]?._id;
			const res = from === 'events'
				? await getEventComments(query)
				: await getComments(path, query);

			afterApiCall(res, query);
		}
		catch (err)
		{
			console.log('---------------', err);
			catchErr(err);
		}

		finally
		{
			setLoading(false);
			loaderRef.current = false;
		}
	};

	useEffect(() =>
	{
		getCommentsList();
	}, [ feedCardActn[1]?._id, cmntData?._id, callApi ]);

	useEffect(() =>
	{
		LoadMoreList();
	}, [ lastEleRef, repliesCount, repliesData ]);

	return (
		<>
			<PostReplies
				from={from} setRepliesData={setRepliesData} commntsData={commntsData}
				repliesData={repliesData} comment={comment}
				feedCardActn={feedCardActn} selEvent={selEvent} setLoading={setLoading}
				setComment={setComment} cmntData={cmntData} setCommntsData={setCommntsData}
			/>
			{loading && <CommentShimmer/>}
			{repliesData && repliesData?.length > 0 && repliesData?.map((reply, index) =>
				(
					<>
						<Replies
							key={reply?._id}
							reply={reply}
							setRepliesData={setRepliesData}
							setAction={setAction}
							repliesData={repliesData}
							from={from}
							handleCmntUpdat={(cmnt) => setComment(cmnt)}
							selEvent={selEvent}
						/>
						{index === repliesData?.length - 2 && <span ref={lastEleRef}/>}
					</>
				))}
			{repliesData && repliesData?.length > 0 &&
				<fieldset className='pointer' style={{ border: 'none' }}>
					<button tabIndex={0} onKeyUp={(e) => { e.key === 'Enter' && openReplies(); }} className='lightTxt headingSM pdngHSM'
						onClick={openReplies}
					>{language?.hide}</button>
				</fieldset>}
		</>
	);
};

export default CommentReply;